/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

import type * as Types from '@root/gql/graphql';

import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { UseQueryResult } from '@tanstack/react-query';
import { QueryClient } from '@tanstack/react-query';
import { gqlRequest } from '@root/gql/utils/gqlRequest';
import { getVouchersQuery } from '../graphs/getVouchers.query';

export type GetVouchersQueryVariables = Types.Exact<{
  dto: Types.GetVouchersDto;
}>;

export type GetVouchersQuery = {
  __typename?: 'Query';
  vouchers?: {
    __typename?: 'VoucherAggregatePaginatedResponseDto';
    data: Array<{
      __typename?: 'VoucherAggregate';
      categoryIds?: Array<number> | null;
      createdAt: Date;
      deletedAt?: Date | null;
      additionalContent?: string | null;
      id: number;
      isPublished: boolean;
      language: string;
      mainImageUrl?: string | null;
      name: string;
      onlyByUri?: boolean | null;
      price: number;
      purchaseLimit?: number | null;
      briefDescription?: string | null;
      termsAndConditions?: string | null;
      type: string;
      updatedAt?: Date | null;
      images?: Array<{
        __typename?: 'ProductImageFieldValue';
        imageUrl: string;
        priority: number;
      }> | null;
      offerPrice?: {
        __typename?: 'GetProductOfferPriceResponseDto';
        discountedPrice: number;
        discountName?: string | null;
        fullPrice: number;
      } | null;
      options?: Array<{
        __typename?: 'ProductOptionEntity';
        createdAt?: Date | null;
        deletedAt?: Date | null;
        id: number;
        language: string;
        name: string;
        price: number;
        updatedAt?: Date | null;
        offerPrice?: {
          __typename?: 'GetProductOfferPriceResponseDto';
          discountedPrice: number;
          discountName?: string | null;
          fullPrice: number;
        } | null;
      }> | null;
      stock?: {
        __typename?: 'ProductAndOptionStockEventAggregation';
        optionStock?: Array<{
          __typename?: 'ProductStockEventAggregation';
          quantity?: number | null;
          optionId?: number | null;
        }> | null;
        productStock?: {
          __typename?: 'ProductStockEventAggregation';
          quantity?: number | null;
        } | null;
      } | null;
      settings?: {
        __typename?: 'ProductSettingsEntity';
        createdAt?: Date | null;
        deletedAt?: Date | null;
        id: number;
        productId: number;
        productLevelQuantity?: number | null;
        quantityLevelSetting: string;
        redemptionValidityPeriodMonths: number;
        salesGeneratedByThirdParties: boolean;
        updatedAt?: Date | null;
      } | null;
    }>;
    meta: {
      __typename?: 'PaginatedResponseMetaDto';
      currentPage: number;
      finalPage: number;
      limitPerPage: number;
      total: number;
    };
  } | null;
};

export const getVouchersQueryImperative = (
  variables: GetVouchersQueryVariables,
  headers?: RequestInit['headers']
) => gqlRequest<GetVouchersQuery, GetVouchersQueryVariables>(getVouchersQuery, variables, headers);

export const getVouchersQueryKey = (variables?: GetVouchersQueryVariables) =>
  ['GetVouchers', variables].filter((x) => x);

export const getVouchersQueryPrefetch = async (
  queryClient: QueryClient,
  variables: GetVouchersQueryVariables,
  options?: {
    headers?: RequestInit['headers'];
  }
) => {
  await queryClient.prefetchQuery(getVouchersQueryKey(variables), () =>
    getVouchersQueryImperative(variables, options?.headers)
  );
};

export const useGetVouchersQuery = <TError = unknown>(
  variables: GetVouchersQueryVariables,
  options?: UseQueryOptions<GetVouchersQuery, TError, GetVouchersQuery>,
  headers?: RequestInit['headers']
): UseQueryResult<GetVouchersQuery> =>
  useQuery<GetVouchersQuery, TError, GetVouchersQuery>(
    ['GetVouchers', variables],
    () => getVouchersQueryImperative(variables as GetVouchersQueryVariables, headers),
    options
  );
